"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetUserMedia = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
/**
 * @description This hook is used to get the user media
 * @param constraint
 * @returns {unknown}
 */
var useGetUserMedia = exports.useGetUserMedia = function useGetUserMedia(_ref) {
  var constraint = _ref.constraint;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    stream = _useState2[0],
    setStream = _useState2[1];
  (0, _react.useEffect)(function () {
    var getStream = /*#__PURE__*/function () {
      var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee() {
        var userMediaStream, _t;
        return _regenerator["default"].wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              _context.next = 1;
              return navigator.mediaDevices.getUserMedia(constraint);
            case 1:
              userMediaStream = _context.sent;
              setStream(userMediaStream);
              _context.next = 3;
              break;
            case 2:
              _context.prev = 2;
              _t = _context["catch"](0);
              console.error('Unable to getUserMedia', _t);
            case 3:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function getStream() {
        return _ref2.apply(this, arguments);
      };
    }();
    getStream();
  }, []);
  return {
    stream: stream
  };
};